import { createAnimation } from '@ionic/react';
import React from 'react';

import { animationKeyFrames } from '../constants';

import type { Animation } from '@ionic/react';

export const useNameAnumation = () => {
  const titleRef = React.useRef<HTMLHeadingElement | null>(null);
  const nameResponseRef = React.useRef<HTMLHeadingElement | null>(null);
  const responseRef = React.useRef<HTMLHeadingElement | null>(null);
  const titleAnimRef = React.useRef<Animation>();

  React.useEffect(() => {
    if (!titleAnimRef.current) {
      const titleA = createAnimation()
        .addElement(titleRef.current!)
        .keyframes(animationKeyFrames.title)
        .afterAddClass('transparent-with-shadow');

      const nameA = createAnimation()
        .addElement(nameResponseRef.current!)
        .keyframes(animationKeyFrames.name)
        .afterAddClass('transparent-with-shadow');

      const repsonse = createAnimation()
        .addElement(responseRef.current!)
        .fill('none')
        .duration(1500)
        .easing('linear')
        .keyframes(animationKeyFrames.response)
        .afterAddClass('color-without-shadow');

      titleAnimRef.current = createAnimation()
        .duration(2000)
        .addAnimation([titleA, nameA, repsonse]);
    }
  }, []);

  const play = async (): Promise<void> => {
    await titleAnimRef.current?.play();
  };

  return {
    titleRef,
    nameResponseRef,
    responseRef,
    play,
  };
};
